<mp-select
  class="select-control truncate"
  [options]="fieldSelectOptions()"
  [selectedValue]="selectedField()"
  (selectedValueChange)="onSelectedFieldChange($event)"
/>
